/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { findCheckboxes, findFieldBlocksOfType, findRadioButtons } from "../../Utils/HtmlUtils";
import { BlockTypes } from "../../Constants/BlockTypes";
import { HtmlAttributes } from "../../Constants/HtmlAttributes";
import { ValidationUtils } from "../../Utils/ValidationUtils";
var SessionsValidator = /** @class */ (function () {
    function SessionsValidator() {
        var _this = this;
        this.onCheckboxValidate = function (form, checkboxes, config) {
            _this.validateMultiSessionSelection(form, checkboxes, config, true);
        };
        this.onRadioValidate = function (form, radiobuttons, config) {
            _this.validateSingleSessionSelection(form, radiobuttons, config, true);
        };
    }
    SessionsValidator.prototype.attachValidation = function (form, config) {
        var _this = this;
        Array.from(findFieldBlocksOfType(form, BlockTypes.blockTypeSessions))
            .filter(function (block) { var _a; return ((_a = block.getAttribute(HtmlAttributes.dataRequired)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true"; })
            .forEach(function (block) {
            _this.attachHandlers(form, block, config);
        });
    };
    SessionsValidator.prototype.attachHandlers = function (form, block, config) {
        var _this = this;
        var checkboxes = Array.from(findCheckboxes(block)).filter(function (checkbox) { return !checkbox.disabled; });
        if (checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.length) {
            this.validateMultiSessionSelection(form, checkboxes, config, false);
            checkboxes.forEach(function (checkbox) {
                ValidationUtils.attachChangeEventHandler(checkbox, function () { return _this.onCheckboxValidate(form, checkboxes, config); });
                ValidationUtils.attachInvalidEventHandler(checkbox, function () { return _this.onCheckboxValidate(form, checkboxes, config); });
            });
            return;
        }
        var radioButtons = Array.from(findRadioButtons(block)).filter(function (radio) { return !radio.disabled; });
        if (radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.length) {
            this.validateSingleSessionSelection(form, radioButtons, config, false);
            radioButtons.forEach(function (checkbox) {
                ValidationUtils.attachChangeEventHandler(checkbox, function () { return _this.onRadioValidate(form, radioButtons, config); });
                ValidationUtils.attachInvalidEventHandler(checkbox, function () { return _this.onRadioValidate(form, radioButtons, config); });
            });
        }
    };
    SessionsValidator.prototype.validateSingleSessionSelection = function (form, radiobuttons, config, displayAccessibleError) {
        this.validateSessionSelection(form, radiobuttons, displayAccessibleError, config.singleSessionRegistrationRequiredErrorMessage);
    };
    SessionsValidator.prototype.validateMultiSessionSelection = function (form, checkboxes, config, displayAccessibleError) {
        this.validateSessionSelection(form, checkboxes, displayAccessibleError, config.sessionRegistrationRequiredErrorMessage);
    };
    SessionsValidator.prototype.validateSessionSelection = function (form, allInputs, displayAccessibleError, errorMessage) {
        var firstInput = allInputs[0];
        ValidationUtils.removeValidationError(form, firstInput);
        allInputs.forEach(function (input) {
            ValidationUtils.setInputValid(input);
        });
        var selected = Array.from(allInputs).filter(function (c) { return c.checked; });
        if (selected.length === 0) {
            allInputs.forEach(function (checkbox) {
                ValidationUtils.setInputInvalid(checkbox, errorMessage);
            });
            if (displayAccessibleError) {
                ValidationUtils.addValidationError(form, firstInput, errorMessage, firstInput.name);
            }
        }
    };
    return SessionsValidator;
}());
export { SessionsValidator };
